import { api } from "./api";

export async function searchEntity(url: string) {
    try {
        const response = await api.get(url, {
            withCredentials: true,
            headers: {
                "Content-Type": "application/json",
            },
        });
        return response.data;
    } catch (error) {
        return { error: (error as Error).message };
    }
}
